import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import BaseList from '../BaseList';
import TierListItem from '../../items/TierListItem';
import { getActiveSection } from '../../../../selectors/studio';
import { StudioSection } from '../../../../types/store';
import { Props } from '../../StudioDeviationList';
import { StudioDeviationListContext } from '../../context';

import s from './TierDeviationList.scss';

const TierDeviationList: FC<Props> = ({ deviations }) => {
  const { ref: actionsColRef, dimensions: actionsDimensions } = useMeasureElement({
    throttle: 250,
    throttleOptions: { trailing: true },
  });

  const activeSection = useSelector(getActiveSection);
  const isUnlisted = activeSection === StudioSection.PRODUCTS_TIER_UNLISTED;

  return (
    <StudioDeviationListContext.Provider
      value={{
        actionsColRef,
        actionsColWidth: actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <BaseList
        className={s['list']}
        results={deviations}
        renderItem={(deviation, idx) => (
          <TierListItem
            key={deviation.deviationId}
            deviation={deviation}
            offset={idx}
            isUnlisted={isUnlisted}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
TierDeviationList.displayName = 'TierDeviationList';

export default TierDeviationList;
